import './ui.js';

import { init } from './init.js';

init();
